export default __webpack_public_path__ + "static/media/98-06_header_invoice.b37c0cf1.png";